import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import MobileBottomNav from "./MobileBottomNav";
import StatusRibbon from "./StatusRibbon";
import CopilotPanel from "@/components/copilot/CopilotPanel";
import { Toaster } from "@/components/ui/sonner";

export default function AppShell() {
    const [collapsed, setCollapsed] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [copilotOpen, setCopilotOpen] = useState(false);

    return (
        <div className="min-h-screen flex bg-background text-foreground pb-[60px] lg:pb-7">
            <div className={`${mobileOpen ? "fixed inset-0 z-40 lg:relative" : "hidden lg:block"}`}>
                <div className={`${mobileOpen ? "fixed inset-0 bg-black/40 lg:hidden" : ""}`} onClick={() => setMobileOpen(false)} />
                <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
            </div>
            <div className="flex-1 flex flex-col min-w-0">
                <TopBar onMobileToggle={() => setMobileOpen(!mobileOpen)} onCopilotOpen={() => setCopilotOpen(true)} />
                <main className="flex-1 overflow-x-hidden">
                    <div className="page-fade">
                        <Outlet context={{ openCopilot: () => setCopilotOpen(true) }} />
                    </div>
                </main>
            </div>
            <CopilotPanel open={copilotOpen} onClose={() => setCopilotOpen(false)} />
            <MobileBottomNav />
            <StatusRibbon />
            <Toaster richColors closeButton position="top-right" theme="dark" />
        </div>
    );
}
